/**
 * Manages the editor sidebar
 */
define('post-editor/sidebar',['post-editor/sidebar-api', 'tinymce/ui/Factory', 
        'post-editor/sidebar-plugins', 'lib/es6-map-shim'],
function(api, Factory, _, _) {
	function Sidebar(editor) {
		this.editor = editor;
		this.sidebarDiv = $('#post-editor-sidebar').empty().show();
		this.uiForGroups = new Map();
	}

	/**
	 * Gets a singleton instance of a DOM element that represents the group defined by def
	 * @param def an object defining the group
	 * @returns an object with properties 'def', 'div' and 'elem'
	 * @private
	 */
	Sidebar.prototype._getUI = function(def) {
		var self = this;

		if (this.uiForGroups.has(def))
			return this.uiForGroups.get(def);

		var originalDef = def;
		if (typeof def == 'function')
			def = def(this.editor);
		
		if ('init' in def)
			def.init(this.editor);

		var heading = $('<h3>').text(def.title);
		var body = $('<div>').addClass('editor-sidebar-group-body');

		var div = $('<div>')
			.addClass('editor-sidebar-group')
			.append(heading)
			.append(body)
			.appendTo(this.sidebarDiv);
		var uiElem = Factory.create(def).renderTo(body[0]);
		
		if ('onRendered' in def)
			def.onRendered(uiElem, this.editor);
		
		var ui = {
			def: def,
			div: div,
			elem: uiElem,
			isExpanded: !def.collapsedByDefault
		};
		this.uiForGroups.set(originalDef, ui);

		heading.click(function() {
			self._toggleGroup(ui);
		});

		return ui;
	};

	Sidebar.prototype._toggleGroup = function(ui) {
		ui.isExpanded = !ui.isExpanded;
		ui.div.toggleClass('expanded', ui.isExpanded);
		ui.div.find('.editor-sidebar-group-body').slideToggle();
	};
	
	Sidebar.prototype._showGroup = function(def, targetElement) {
		var ui = this._getUI(def);
		
		if ('onOpen' in ui.def)
			ui.def.onOpen(ui.elem, targetElement, this.editor);

		// Move the div to the bottom
		ui.div.detach().appendTo(this.sidebarDiv).show();
		ui.elem.reflow();

		ui.div.toggleClass('expanded', ui.isExpanded);
		if (!ui.isExpanded) {
			ui.div.find('.editor-sidebar-group-body').hide();
		}
	};
	
	Sidebar.prototype._hideAllUIs = function() {
		this.sidebarDiv.children().hide();
	};
	
	Sidebar.prototype.showForElement = function(selectedElement) {
		this._hideAllUIs();
		if (!selectedElement)
			return;
		var groups = api.getGroupsForElement(selectedElement);
		
		groups.forEach(function(group) {
			this._showGroup(group.def, group.element);
		}.bind(this));
	}
	
	return Sidebar;
});

